// extracted by mini-css-extract-plugin
export default {"feedback_page":"Feedback_feedback_page__Y-ZbR","feedback_form":"Feedback_feedback_form__mO0hn","feedback_form__title":"Feedback_feedback_form__title__RYT+2"};